import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { scrollToTop } from 'src/core';
export interface SettlementEnquiryThankyouPageProps extends BaseComponentProps {
    lang: string;
    history?: History;
}

export interface SettlementEnquiryThankyouPageState extends BaseComponentState { }

export class SettlementEnquiryThankyouPage extends BaseComponent<SettlementEnquiryThankyouPageProps, SettlementEnquiryThankyouPageState> {

    constructor(props: SettlementEnquiryThankyouPageProps) {
        super(props);
    }

    componentDidMount() {
        scrollToTop();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div>
                <h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>

                <p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com/terms-of-use" target="_blank">https://www.balihotelsandmore.com/terms-of-use</a></p>

                <p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>

                <p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>

                <p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/" target="_blank">https://www.solemen.org</a> &nbsp;</p>

                <p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/" target="_blank">https://www.stellaschild.org/</a></p>

                <p>Your booking really does make a difference here in Bali!</p>

                <p>We look forward to speaking to you within the next 24 - 48 hours.</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/SettlementEnquiryThankyouPage.tsx